const element = $('[data-sticky]');

element.each(() => {
	const placeholder = $(
		'<div class="sticky-placeholder" style="position: absolute"></div>'
	);

	if (placeholder.parent() !== parent) {
		element.before(placeholder);
	}

	const options = {
		position: element.attr('data-sticky')
	};

	let prevStickyMode;

	const render = () => {
		const parent = element.parent();
		const parentOffset = parent.offset();
		const elementOffset = element.offset();
		// const placeholderOffset = placeholder.offset();
		const elementCSSTop = elementOffset.top - parentOffset.top;
		// const elementCSSLeft = elementOffset.left - parentOffset.left;

		const scrollTop = $(window).scrollTop();
		const elementOffsetTop = (prevStickyMode ? placeholder : element).offset()
			.top;

		const fixedPosition
			= options.position === 'top' ?
				elementCSSTop
				: parentOffset.top
					+ parent.innerHeight()
					- (elementOffset.top + element.outerHeight());

		const stickyMode
			= options.position === 'top' ?
				scrollTop > elementOffsetTop
				: scrollTop + $(window).height()
					< elementOffsetTop + element.outerHeight();

		// side effects

		if (prevStickyMode !== stickyMode && stickyMode) {
			placeholder.css({
				position: 'static',
				//width: element.outerWidth() + "px",
				height: element.outerHeight() + 'px'
			});

			element.css({
				//width: element.outerWidth() + "px",
				//height: element.outerHeight() + "px",
				[options.position]: fixedPosition + 'px',
				left: elementOffset.left + 'px',
				position: 'fixed'
			});
		}

		if (prevStickyMode !== stickyMode && !stickyMode) {
			element.css({
				width: '',
				height: '',
				position: 'static'
			});

			placeholder.css({
				position: 'absolute'
			});
		}

		if (stickyMode) {
			element.css({
				//width: parent.width() + "px"
			});
			placeholder.css({
				width: element.outerWidth() + 'px'
			});
		}

		prevStickyMode = stickyMode;

		requestAnimationFrame(render);
	};

	requestAnimationFrame(render);
});



// WEBPACK FOOTER //
// ../work/src/js/sticky.js